import React from "react";
import video1 from "assets/images/website/features-management.svg";
import video2 from "assets/videos/website/numbers2.mp4";
import video3 from "assets/videos/website/numbers3.mp4";

const Stats: React.FC = () => {
  return (
    <section className="bg-white/70 dark:bg-secondary-900/40 ">
      <div className="mx-auto my-0 max-w-7xl px-2 py-6 md:p-[32px] text-gray-900">
        <div className="flex w-full flex-col items-center justify-center md:gap-12 gap-10">
          <div className="w-full flex flex-col md:flex-row gap-6 md:gap-8">
            <div className="flex flex-1 md:flex-col flex-row-reverse p-6 py-4 md:p-8 justify-between items-center bg-[#F6F7F9] rounded-[12px] md:rounded-[20px] max-md:max-h-[144px] md:h-[337px]">
              <div className="max-md:flex-1 justify-end flex">
                {/* <video
                  preload="auto" autoPlay muted loop className="w-[236px] h-[136px]"
                >
                  <source
                    src={video1}
                    type="video/mp4"
                  />
                </video> */}
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
              </div>
              <div className="flex gap-2 flex-col items-start w-full max-md:flex-1">
                <h3 className="text-[28px] leading-[35px] font-[500] tracking-[-1.2px] md:text-[36px] md:leading-[43px] md:tracking-[-1.8px] md:font-[450]">
                  <span>10</span>K +
                </h3>
                <p className="text-[14px] leading-[19px] font-[450] tracking-[-0.2px] md:text-[16px] md:leading-[22px] md:tracking-[-0.4%] md:font-[400] text-gray-500">
                  Trusted by professionals
                </p>
              </div>
            </div>
            <div className="flex flex-1 md:flex-col flex-row-reverse p-6 py-4 md:p-8 justify-between items-center bg-[#F6F7F9] rounded-[12px] md:rounded-[20px] max-md:max-h-[144px] md:h-[337px]">
              <div className="max-md:flex-1 justify-end flex">
                {/* <video preload="auto" autoPlay muted loop className="w-[190px] h-[168px]">
                  <source
                    src={video2}
                    type="video/mp4"
                  />
                </video> */}
                
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
              </div>
              <div className="flex gap-2 flex-col items-start w-full max-md:flex-1">
                <h3 className="text-[28px] leading-[35px] font-[500] tracking-[-1.2px] md:text-[36px] md:leading-[43px] md:tracking-[-1.8px] md:font-[450]">
                  <span>20</span> +
                </h3>
                <p className="text-[14px] leading-[19px] font-[450] tracking-[-0.2px] md:text-[16px] md:leading-[22px] md:tracking-[-0.4%] md:font-[400] text-gray-500">
                  Countries worldwide
                </p>
              </div>
            </div>
            <div className="flex flex-1 md:flex-col flex-row-reverse p-6 py-4 md:p-8 justify-between items-center bg-[#F6F7F9] rounded-[12px] md:rounded-[20px] max-md:max-h-[144px] md:h-[337px]">
              <div className="max-md:flex-1 justify-end flex">
                {/* <video
                  preload="auto" autoPlay muted loop className="w-[179px] h-[151px]"
                >
                  <source
                    src={video3}
                    type="video/mp4"
                  />
                </video> */}
                
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
              </div>
              <div className="flex gap-2 flex-col items-start w-full max-md:flex-1">
                <h3 className="text-[28px] leading-[35px] font-[500] tracking-[-1.2px] md:text-[36px] md:leading-[43px] md:tracking-[-1.8px] md:font-[450]">
                  <span>4.5</span>
                </h3>
                <p className="text-[14px] leading-[19px] font-[450] tracking-[-0.2px] md:text-[16px] md:leading-[22px] md:tracking-[-0.4%] md:font-[400] text-gray-500">
                  Rating
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
